import { InviteCode } from '@root/entities/referral'

import type { OAuthState } from '@root/entities/auth'

export type TwitterAuthAction = 'login' | 'register' | 'assign'
const TWITTER_AUTH_ACTIONS = new Set<TwitterAuthAction>([
  'login',
  'register',
  'assign',
])

const refineTwitterAuthAction = (str: string): str is TwitterAuthAction =>
  TWITTER_AUTH_ACTIONS.has(str)

export const parseTwitterAuthAction = (
  state: OAuthState,
): {
  action: TwitterAuthAction | undefined
  referralCode: InviteCode | undefined
} => {
  try {
    const decoded = window.atob(state)
    const payload = JSON.parse(decoded) as {
      action: string
      referralCode?: string
    }

    return {
      action: refineTwitterAuthAction(payload.action)
        ? payload.action
        : undefined,
      referralCode: payload.referralCode
        ? InviteCode(payload.referralCode)
        : undefined,
    }
  } catch {
    return { action: undefined, referralCode: undefined }
  }
}
